// extracted by mini-css-extract-plugin
module.exports = {"item":"A4VDVT8YKMiqy61guBjsk","selItem":"_3pg4q0yzl2NjRjOfDZ5Ewu"};